/** Local MY mobile: `12 345 6789` (2 + 3 + remaining digits). */
export function formatLocalDigits(localDigits: string): string {
  const d = localDigits.replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)} ${d.slice(2)}`;
  return `${d.slice(0, 2)} ${d.slice(2, 5)} ${d.slice(5)}`;
}

/** Digits only; strips leading 60 if user pastes a full MY number. */
export function parseLocalMobileInput(raw: string): string {
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('60')) digits = digits.slice(2);
  return digits.slice(0, 11);
}

const MY_MOBILE_CONTACT_RE = /^601[0-9]{8,9}$/;

const BANNED_NATIONAL_DIGITS = new Set([
  '12345678',
  '123456789',
  '1234567890',
  '12345678901',
  '98765432',
  '987654321',
  '9876543210',
  '012345678',
  '0123456789',
]);

function isRepeatedDigits(s: string): boolean {
  return s.length >= 6 && /^(.)\1+$/.test(s);
}

function isKeyboardSequential(s: string): boolean {
  if (s.length < 8) return false;
  const asc = '01234567890123456789';
  const desc = '09876543210987654321';
  return asc.includes(s) || desc.includes(s);
}

function isRepeatedBlock(s: string): boolean {
  if (s.length < 6) return false;
  for (let size = 1; size <= Math.floor(s.length / 2); size++) {
    if (s.length % size !== 0) continue;
    const unit = s.slice(0, size);
    if (unit.repeat(s.length / size) === s) return true;
  }
  return false;
}

function toContactDigits(localDigits: string): string {
  let d = localDigits.replace(/\D/g, '');
  if (d.startsWith('60')) d = d.slice(2);
  d = d.replace(/^0+/, '');
  return d.length === 0 ? '' : `60${d}`;
}

/** Same rules as backend OTP: MY mobile shape, not sequential/dummy. */
export function isAcceptableMalaysiaMobileInput(localDigits: string): boolean {
  const contact = toContactDigits(localDigits);
  if (!MY_MOBILE_CONTACT_RE.test(contact)) return false;
  const national = contact.slice(2);
  if (BANNED_NATIONAL_DIGITS.has(national)) return false;
  if (isRepeatedDigits(national)) return false;
  if (isKeyboardSequential(national)) return false;
  if (isRepeatedBlock(national)) return false;
  return true;
}

/** Display e.g. `+60 12 345 6789` for the local digit string (no country prefix in storage). */
export function displayFullMalaysiaMobile(localDigits: string): string {
  const f = formatLocalDigits(localDigits);
  if (!f) return '+60';
  return `+60 ${f}`;
}
